import React, { ReactElement } from 'react';

import { css, Global } from '@emotion/react';

function GlobalStyle(): ReactElement {
  return (
    <Global
      styles={css`
        input::placeholder {
          color: #ccc !important;
          position: absolute;
          line-height: 22px;
        }

        html,
        body {
          height: 100%;
          width: 100%;
          line-height: 1.5;
          font-family: Lato, NotoSansCJKkr, sans-serif !important;
        }

        input,
        button,
        span,
        a {
          letter-spacing: 0.5px;
          /* word-break: keep-all; */
        }

        #root {
          min-height: 100%;
          min-width: 100%;
          font-family: Lato, NotoSansCJKkr, sans-serif !important;
        }

        span.ant-checkbox-checked:after {
          border: none !important;
        }

        span.ant-checkbox-checked > .ant-checkbox-inner {
          background-color: #1d1c1d !important;
          border: none !important;
          color: #ffffff;
        }

        header.ant-layout-header {
          background: #ffffff;
          line-height: 55px;
        }

        .react-stars span {
          margin-left: 4.5px;
          margin-right: 4.5px;
        }
      `}
    />
  );
}

export default GlobalStyle;
